<template>
  <div>
    <v-form ref="fileInputForm" @submit.prevent="">
      <v-row>
        <v-col class="col-4">
          <destination-selector
            :selected-destination.sync="selectedDestination"
            :permission="permission"
          />
        </v-col>
        <v-col class="col-4">
          <v-file-input
            ref="fileUploader"
            :rules="rules"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :label="$t('productsImport.fileInputLabel')"
            show-size
            outlined
            @change="tmpSaveFile"
          />
        </v-col>
        <v-col class="col-4">
          <v-btn class="mt-2" color="primary" @click="askToImport()">
            <span class="fal fa-file-upload mr-2" />
            {{ $t('productsImport.upload') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <!-- modal asking for import -->
    <s-modal
      ref="askToImportProducts"
      :size="2"
      :ok-text="$t('productsImport.overwrite')"
      :header-text="$t('productsImport.reallyImport')"
      @ok="importProducts()"
    >
      <v-row>
        <v-col class="col-12">
          <span class="fal fa-exclamation-triangle mr-2 red--text" />
          {{ $t('productsImport.importCannotBeUndone') }}
        </v-col>
      </v-row>
    </s-modal>
  </div>
</template>

<script>
import FileUploadService from '../../classes-shared/files/FileUploadService'
import DestinationSelector from '@/components-internal/settings/DestinationSelector'
import definitions from '../../../definitions'

export default {
  name: 'ProductsImport',
  components: { DestinationSelector },
  data() {
    return {
      uploadService: new FileUploadService(),
      rules: [
        (value) => !!value || i18n.t('productsImport.required'),
        (value) => {
          if (
            value &&
            !(
              value.type ===
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
          ) {
            return i18n.t('productsImport.wrongFileType')
          }
          return true
        },
      ],
      file: null,
      selectedDestination: null,
      permission: definitions.permissions.engine.PE_POST_IMPORTS,
    }
  },
  methods: {
    askToImport() {
      if (this.$refs.fileInputForm.validate() && this.file) {
        this.$refs.askToImportProducts.show()
      }
    },
    async importProducts() {
      // check file name corresponds to selected destination
      const destinationSlugByFileName = this.file.name
        .toLowerCase()
        .split('.xlsx')[0]
      if (destinationSlugByFileName !== this.selectedDestination.getSlug()) {
        EventBus.$emit('notify', this.$t('productsImport.wrongFileName'))
        return
      }

      if (this.file && this.$refs.fileInputForm.validate()) {
        await this.uploadService.importProductsFromExcel(this.file)
      }
    },
    tmpSaveFile(file) {
      this.file = file
    },
  },
}
</script>
